import React from 'react';
import { Spinner } from 'react-bootstrap';

import Icon from 'components/DesignSystem/Icon';
import { Comparison } from 'helper/products/meteorology';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function ComparisonList({
  items,
  isFetching,
  isSelected,
  onSelect,
  onDelete,
  deleteLoading = false,
  emptyMessage,
}: {
  items: Comparison[];
  isFetching: boolean;
  isSelected: (item: Comparison) => boolean;
  onSelect: (item: Comparison) => void;
  onDelete?: (item: Comparison) => void;
  deleteLoading?: boolean;
  emptyMessage: string;
}) {
  if (isFetching) {
    return <div className="text-center py-4"><Spinner /></div>;
  }

  if (items.length === 0) {
    return <p className="comparison-list-empty">{emptyMessage}</p>;
  }

  return (
    <ul className="comparison-list list-unstyled mb-0">
      {items.map((item) => {
        const selected = isSelected(item);
        return (
          <li key={item.id} className="comparison-list-item">
            <button
              type="button"
              className="comparison-list-item-main"
              onClick={() => onSelect(item)}
            >
              <span className="comparison-list-item-name">{item.name}</span>
              <span className="comparison-list-item-badge">{item.json.confrontante.modelo}</span>
            </button>
            {selected && <Icon iconType="checkmark" color={cssVar('text-accent')} />}
            {onDelete && (
              <button
                type="button"
                className="comparison-list-item-delete"
                aria-label={`Remover ${item.name}`}
                disabled={deleteLoading}
                onClick={() => onDelete(item)}
              >
                <Icon iconType="trash" color={cssVar('text-secondary')} />
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
